module.exports = __webpack_public_path__ + "img/cgc.225b8da6.svg";